import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'custom-error-toast',
  templateUrl: './custom-error-toast.component.html'
})
export class CustomErrorToastComponent {
  @Input()
  messages!: string[];

  @Output()
  onReject: EventEmitter<any> = new EventEmitter();

  onClose(): void {
      this.onReject.emit();
  }
}
